import { request } from "@/api";
import type { GetProductLayoutsRequest } from "@/api/interfaces/productLayouts";
import { ApiPath } from "@/api/paths";
import type { ApiRequest, RequestResponse } from "@/api/types";
import type { ProductLayoutData } from "@/store/products/types";

const getProductLayouts: ApiRequest<
  RequestResponse<ProductLayoutData>,
  GetProductLayoutsRequest
> = async ({ productLayoutID, diningOptionId, ...options }) =>
  request({
    ...options,
    api: ApiPath.Product.getProductLayouts({
      productLayoutID,
      diningOptionId,
    }),
  });

const ProductLayouts = {
  getProductLayouts,
};

export { ProductLayouts };
